import { render, staticRenderFns } from "./case8.vue?vue&type=template&id=a2bc3d84&scoped=true&"
import script from "./case8.vue?vue&type=script&lang=js&"
export * from "./case8.vue?vue&type=script&lang=js&"
import style0 from "./case8.vue?vue&type=style&index=0&id=a2bc3d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bc3d84",
  null
  
)

export default component.exports